import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import './../RequestsItem/RequestsItem.scss';
import moment from 'moment';
import {formatPrice, getMyRequestsStatus, getStatusColor} from "../../../../helpers/functions";


class RequestsItem extends Component {

    render() {
        const {item, isExpanded, onToggleExpansion} = this.props;

        const isExpandable = item.product_info && item.product_info.length > 1;
        const mainProduct = item.product_info[0];
        const showExtra = isExpandable && !isExpanded;

        const checkChildTagHandler = (event) => {
            if (event.target.closest('span')) {
                event.preventDefault();
            }
        };

        return (
            <React.Fragment>
                <Link className="table_row" to={`/admin/refund-request/${item.id}`} onClick={(e) => checkChildTagHandler(e)}>
                    <div className="row_orders">
                        <div className="row_item" style={{ cursor: isExpandable ? 'pointer' : 'default' }} onClick={(e) => {e.preventDefault();e.stopPropagation(); isExpandable && onToggleExpansion(item.id)}}>
                            {isExpandable ? (
                                <span>{isExpanded ? '▼' : '▶'}</span>
                            ) : null}
                        </div>
                        <div className="row_item">
                            <div>{item.document_number || ''}</div>
                        </div>
                        <div className="row_item">
                            <div>{mainProduct.name || ''}</div>
                        </div>
                        <div className="row_item">
                            <div>{mainProduct && mainProduct.article_number}</div>
                        </div>
                        <div className="row_item">
                            <div>{Array.isArray(item.ordernum) ? item.ordernum[0] : item.ordernum}{showExtra && Array.isArray(item.ordernum) && item.ordernum.length > 1 ? <span style={{ color: '#888', fontSize: 12, marginLeft: 4 }}>{`+${item.ordernum.length - 1}`}</span> : null}</div>
                        </div>
                        <div className="row_item">
                            <div>{mainProduct.producer}</div>
                        </div>
                        <div className="row_item">
                            <div>{moment(item.date).format('DD.MM.YYYY HH:mm')}</div>
                        </div>
                        <div className="row_item">
                            <div className="block_status">
                                <span
                                    className="status_orders"
                                    style={{ background: `${getStatusColor(item.status)}` }}
                                />
                                {getMyRequestsStatus(item.status)}
                            </div>
                        </div>
                        <div className="row_item">
                            <div>{item.amount}</div>
                        </div>
                        <div className="row_item">
                            <div>{formatPrice(item.price)}</div>
                        </div>
                    </div>
                </Link>
                {isExpanded && isExpandable && item.product_info.map((prod, idx) => (
                    <div className="table_row" key={idx} style={{ background: '#f9f9f9', fontSize: 13 }}>
                        <div className="row_orders">
                            <div className="row_item"></div>
                            <div className="row_item">{item.document_number || ''}</div>
                            <div className="row_item">{prod.name}</div>
                            <div className="row_item">{prod.article_number}</div>
                            <div className="row_item">{prod.ordernum || ''}</div>
                            <div className="row_item">{prod.producer}</div>
                            <div className="row_item"></div>
                            <div className="row_item"></div>
                            <div className="row_item">{prod.amount}</div>
                            <div className="row_item">{formatPrice(prod.price)}</div>
                        </div>
                    </div>
                ))}
            </React.Fragment>
        );
    }
}

export default RequestsItem;